import { SelectList } from 'complex-data'
import { SelectListValueType } from 'complex-data/src/data/SelectList'
import ApiData from '@/api/class/ApiData'
import selectApi, { cascaderValue, dictRes } from '../api/select'
import { CascaderListValueType } from '@/class/CascaderList'

export function loadDefaultDict(select: SelectList<SelectListValueType<string>>, api: ApiData<[], dictRes>) {
  return new Promise((resolve, reject) => {
    api.require().then(res => {
      select.setList(res.data.data.map(item => {
        return {
          value: item.key,
          label: item.value
        }
      }))
      resolve({ status: 'success' })
    }).catch(err => {
      reject(err)
    })
  })
}

export function loadDefaultDictList(api: ApiData<[], dictRes>): Promise<{ status: string, list: SelectListValueType<string>[] }> {
  return new Promise((resolve, reject) => {
    api.require().then(res => {
      const list = res.data.data.map(item => {
        return {
          value: item.key,
          label: item.value
        }
      })
      resolve({ status: 'success', list: list })
    }).catch(err => {
      reject(err)
    })
  })
}

function formatCascader(list: cascaderValue[]): CascaderListValueType<string>[] {
  return list.map(item => {
    return {
      value: item.key,
      label: item.value,
      children: item.childrenList ? formatCascader(item.childrenList) : undefined
    }
  })
}

export function loadDefaultCascaderList(code: string, childrenCode: string): Promise<{ status: string, list: CascaderListValueType<string>[] }> {
  return new Promise((resolve, reject) => {
    selectApi.cascader.require({
      code,
      childrenCode
    }).then(res => {
      const list = formatCascader(res.data.data)
      resolve({ status: 'success', list: list })
    }).catch(err => {
      reject(err)
    })
  })
}
